import { Blog, BlogService } from '..';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { Image } from '../../property/image/property-image';
import { PictureService } from '@app/_components/picture/picture.service';
import { first } from 'rxjs';
import { SpringQuery } from '@app/_helpers/spring-query';
import { DevelopmentService } from '@app/_components/development/development.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class BlogComponent implements OnInit {
	pictureList: any[]=[];
	countNumber: number = 0;
	images: any[] = [];
	isPicture = false;
	locationCategories: any[];
	locations: any[];
	types: any;
	developments: any;
	constructor(
		private primengConfig: PrimeNGConfig,
		private constantService: ConstantService,
		private pictureService: PictureService,
		private blogService: BlogService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private developmentService: DevelopmentService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.blog = data.blog,
		this.statuses = blogService.statuses,
		this.types = blogService.types;
		this.locationCategories = this.constantService.locations;
		this.locations = this.constantService.locations;
	}

	@Input() blog: Blog;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	blogId: number;
	count: number;
	pictureProperties: any = {};
	pictureData: any;
    pictureIndex: number;

	// data
	uploadedFiles: any[] = [];
	pictureArray: any[] = [];
	pictures: any[] = [];
	pictureSorting: any[] = [];
	image: Image;
	forDeletePictures: any[] = [];


	// datalist
	lazyLoadEvent: LazyLoadEvent;
	recordTotal: number;
	loading = false;
	multiSortMeta = [];
	first = 0;
	rows = 50;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	columns: any[] = [
		{ field: 'pictureId', header: 'pictureId', width: 'auto' },
	];

	validationMessages = {
		'type': [],
		'blogId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		keywordsForSeo: [],
		urlLinkTitle: [],
		urlLink: [],
		leadDescription: [],
		locationId: [],
		statementMonth: [],
		blogDevelopmentAPIList: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.loadDevelopments();

		// if we were passed the whole blog object
		if (this.blog) {
			this.blogId = this.blog.blogId;
			this.formById();
			// this.blog.pictures.forEach(picture => {
			// 	const pictureObj = {
			// 		title: picture.fileName,
			// 		value: this.generateUrl(picture.url)
			// 	}
			// 	this.pictureList.push(pictureObj);
			// });
			// this.fixDates();
			// this.form1.patchValue(this.blog);
		}
	}

	loadDevelopments() {
		this.formLoading = true;
		this.developmentService.developmentSummaryList().pipe(first()).subscribe(

			data => {
				this.developments = data.data.developmentSummaryList;
				if (this.blog) {
					this.form1.patchValue({
						blogDevelopmentAPIList: this.blog.blogDevelopmentAPIList
					});
				}
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}

	onTypeChange(event: any) {
		console.log('onTypeChange: ' + JSON.stringify(event));
		this.form1.get('locationId').setValue(null);
		this.form1.get('statementMonth').setValue(null);

		let featureTitle = event.value === 1 ? 'Blog' : 'Statement';
		this.formTitle = this.blogId ? 'Edit ' + featureTitle : 'Add ' + featureTitle;
	}

	selectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = true;
			this.forDeletePictures.push(this.pictures[index].pictureId);
		}
		console.log("forDeletePictures after select all : "+this.forDeletePictures);
	}
	
	unSelectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = false;
		}
		console.log("forDeletePictures after deselect all : "+this.forDeletePictures);
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.blogId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			
			if (this.form1.value.statementMonth) {
				this.form1.value.statementMonth = moment(this.form1.value.statementMonth).format('MM/YYYY');
			} else {
				this.form1.value.statementMonth = null;
			}
			
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.loading = true;
			this.blogService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						this.loading = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.blog = res.data.blog;
						this.blogId = this.blog.blogId;
						this.doAdd.emit(this.blog);
					},
					(err: any) => {
						console.log('blog-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.loading = false;
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('blog: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.loading = true;
			this.form1.value.blogId = this.blogId;
			
			if (this.form1.value.statementMonth) {
				this.form1.value.statementMonth = moment(this.form1.value.statementMonth).format('MM/YYYY');
			} else {
				this.form1.value.statementMonth = null;
			}
			
			this.blogService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						this.loading = false;
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.blog = res.data.blog;
						this.doUpdate.emit(this.blog);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			this.loading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	

	formDelete() {
		try {
			this.blogService.delete(this.blog.blogId)
				.subscribe(
					(res: any) => {
						console.log('blog-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.blog);
					},
					(err: any) => {
						console.log('blog-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			blogId: [this.blogId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: ['', Validators.required],
			status: ["A"],
			type: [1],
			keywordsForSeo: [],
			urlLinkTitle: [],
			urlLink: [],
			leadDescription: [],
			locationId: [],
			statementMonth: [],
			blogDevelopmentAPIList: []
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		// this.blog.blogDate = moment(this.blog.blogDate).toDate();
	}

	myUploader(event: any) {
		this.pictureIndex = 0;
		this.uploadedFiles = event.files;
		this.uploadPicture();
	}
	
	uploadPicture() {
		this.formLoading = true;
		console.log('File name: ' + JSON.stringify(this.uploadedFiles[this.pictureIndex].name));
		try {
			this.pictureService.uploadFileForBlog(this.uploadedFiles[this.pictureIndex], this.blogId)
				.subscribe(
					res => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							this.loadLazy(this.lazyLoadEvent);
							this.isPicture = false;
							this.formById();
							this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload All Image Successfully" });
							this.formLoading = false;
						}
						console.log('Update picture successfully: ' + JSON.stringify(res));
					},
					err => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							// this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
						console.log('Update picture sort order FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { 
						if (this.uploadedFiles.length == this.pictureIndex) {
							// this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}

	generateUrl(url: any){
		return url.replace(/img/gi, "s3.us-east-1.amazonaws.com/img");;
	  }

	  formById() {
		this.loading = true;
		try {
			this.blogService.findById(this.blogId)
				.subscribe(
					(res: any) => {
						this.loading = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.blog = res.data.blog;
						this.blogId = this.blog.blogId;
						this.form1.patchValue(this.blog);
						if (this.blog?.statementMonth) {
							const parsedDate = moment(this.blog.statementMonth, ['MM/YYYY', 'YYYY-MM-DD', 'YYYY-MM', moment.ISO_8601], true);
							if (parsedDate.isValid()) {
								const dateObj = parsedDate.startOf('month').toDate();
								this.form1.get('statementMonth').setValue(dateObj);
							} else {
								this.form1.get('statementMonth').setValue(null);
							}
						} else {
							this.form1.get('statementMonth').setValue(null);
						}
						// this.pictureList = [];
						this.countNumber = 0;
						this.blog.pictures.forEach(picture => {
							this.countNumber = this.countNumber + 1;
							if(this.pictureList.length < this.countNumber){
								const pictureObj = {
									title: this.blog.pictures[this.pictureList.length].fileName,
									value: this.generateUrl(this.blog.pictures[this.pictureList.length].url)
								}
								this.pictureList.push(pictureObj);
							}
						});
					},
					(err: any) => {
						this.loading = false;
						console.log('blog-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.loading = false;
			this.alertService.error(error);
		}
	}

	/********** Load Images from DB **********/
	loadLazy(event: LazyLoadEvent) {
		try {
			// this.formLoading = true;
			this.lazyLoadEvent = event;
			const pageNumber = Math.round(event.first / event.rows);

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			// If we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			let springQuery = new SpringQuery();
			springQuery.addEquals('size', '200');
			if (this.blogId) {
				springQuery.addEquals('blogVO.blogId', this.blogId.toString())
			}

			this.pictureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters,
				springQuery).pipe(first()).subscribe(

					res => {
						console.log('Load SUCCESS: ' + JSON.stringify(res))
						this.pictures = res.data.pictures;
						if(this.pictures.length > 0){
							this.isPicture = false;
						}else{
							this.isPicture = true;
						}
						this.recordTotal = res.page.recordTotal;
						this.formLoading = false;
					},
					err => {
						console.log('Load FAIL: ' + JSON.stringify(err));
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, sticky: true });
					},
					() => { this.formLoading = false; }
				);

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, sticky: true });
		}
	}

	/********** Delete Image from DB + S3 **********/
	deleteMultiplePictures() {
		try {
					this.formLoading = true;
					this.pictureService.removeMultipleBlogPicture(this.forDeletePictures)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								for (let i = 0; i < this.forDeletePictures.length; i++) {
								  this.pictures.splice(this.pictures.indexOf(this.forDeletePictures[i]), 1);
								}
								this.forDeletePictures = [];
								this.images = this.pictures;
								this.loadLazy(this.lazyLoadEvent);
								this.recordTotal = this.pictures.length;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
	}

	/********** Delete Image from DB + S3 **********/
	onDelete(image) {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + image.pictureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				try {
					this.formLoading = true;
					this.pictureService.removeBlogPicture(image.pictureId)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								this.pictures.splice(this.pictures.indexOf(image), 1);
								this.images = this.pictures;
								this.loadLazy(this.lazyLoadEvent);
								this.recordTotal = this.pictures.length;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	addIntoCheckedList(picture: any){
		if (this.forDeletePictures.includes(picture.pictureId)) {
			this.forDeletePictures.splice(this.forDeletePictures.indexOf(picture.pictureId), 1);
		}else{
			this.forDeletePictures.push(picture.pictureId);
		}
		console.log("forDeletePictures : "+this.forDeletePictures);
	}

	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		// this.onOpenFormEdit(event.data);
	}

	// generate random digits
	gfg() {
		return new Date(Date.now()+(new Date().getTimezoneOffset()*60000)).getTime();
	} 

	getLocationName(locationId: any) {
		if(locationId) {
			let locationName = this.locations.find(location => location.locationId === locationId)?.name;
			return locationName ? ` - ${locationName}` : '';
		}
		return '';
	}
	
}
